/**
 * ページ読み込み時のイベント設定
 */
window.dashboard_base_event_set = function () {

    // 画面切り替え時
    $(document).on("click", 'input[name="screen_type"]', function(){
        var str = $(this).val();
        let newUrl = currentUrl = window.location.href;
        if (currentUrl.includes('bss/dashboard')) {
            if(str==0){
                newUrl = currentUrl.replace('bss/', '');
            }
        }
        else
        {
            if(str==1){
                newUrl = currentUrl.replace('/dashboard', '/bss/dashboard');
            }
        }
        if(newUrl != currentUrl){
            window.location.href = newUrl; 
        }
    });

    // カレンダーの切り替え時
    $(document).on('click', '.calendar-date', function() {
        var date = $(this).data('date');
        $('#search-form-current').val(date);
        // 非表示処置
        $('.calendar-date.active').removeClass('active');
        $('.calendar-date-detail').addClass('display-none');
        // 表示処理
        $(this).addClass('active');
        $('.calendar-date-detail[data-date=' + date + ']').removeClass('display-none');
    });

    // お知らせ：詳細表示
    $(document).on('click', '[data-dashboard-announcement-detail]', function () {
        _modal.create(this, 'detail-modal', ['id']);
        return false;
    });

    // お知らせ：一覧表示（+◯件）
    $(document).on('click', '[data-dashboard-announcement-list]', function () {
        _modal.create(this, 'detail-modal', []);
        return false;
    });

}

/**
 * 設定モーダルのイベント設定
 */
window.dashboard_base_setting_event_set = function () {
}
